// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { RegistrarService } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Registrar';
import { ERR_REJ_MINT, SUC_REJ_MINT } from '../../../../utils/strings';

export const useRejectMintRequest = () => {
  const { submit } = useExerciseSubmission(
    RegistrarService.RegistrarService_RejectMintRequest,
    SUC_REJ_MINT,
    ERR_REJ_MINT,
  );
  return submit;
};
